






























































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import PMPLineItem from "./Components/PMPLineItems.vue";
import "@/styles/iucn/project-monitoring-plan.css";
import { Workspace } from "@/entities";
const namespace: string = "application";

@Component({
  components: {
    PMPLineItem,
  },
})
export default class PMPComponent extends Vue {
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Prop({ default: true }) allowMultiple: boolean;
  @Prop({ default: true }) allowCustomIndicator: boolean;
  
  @Getter("indicators", { namespace: "application" }) items: any;
  @Getter("applicationId", { namespace: "application" }) ApplicationId: any;
  @Action("createCustomIndicator", { namespace: "application" })
  createCustomIndicator: any;
  @Action("updateCustomIndicator", { namespace: "application" })
  @State(namespace) application!: Workspace;
  updateIndicator: any;

  key: number = 0;
  search: string = "";
  indicatorDialog: boolean = false;
  monitoringPlan: any = [];
  indicators: any = [];
  selected: any = [];
  frequencyOptions: any = [];
  MeIndicatorType = [];
  useCustomIndicator: boolean = false;
  activeTab = 0;
  selectedResultId: string = "";
  newObj: any = {};
  editDialog: boolean = false;
  selectedObj: any = {};
  selectedIndex: number = 0;
  hiddenChild = [];
  cusIndex = 1;

  get customIndicatorDataTypes() {
    return _app.customIndicatorDataTypes.map(x => {
      x.DisplayText = this.$t(x.DisplayText).toString()
      return x
    });
  }

  mounted() {
    this.$services.application.getFrequencyOptions().then((resp: any) => {
      if (resp.Result === "OK") {
        this.frequencyOptions = resp.Record;
      }
    });
    this.$services.application.getIndicatorDataTypes().then((data: any) => {
      if (data.Result === "OK") {
        this.MeIndicatorType = data.Record;
      }
    });
    this.items.map((x) => {
      if (!x.IsStandard) {
        this.cusIndex += 1;
      }
    });
    this.headers.map((x) => {
        x.text = this.$t(x.text);
    });
  }

  /** Remove the used items and custom indicators from the list*/
  filteredItems() {
    var usedIds = [];
    //allows same indicators multiple times for different results
    if(this.allowMultiple)
    {
      if(this.selectedResultId && this.indicatorMapping[this.selectedResultId])
      {
        usedIds=this.indicatorMapping[this.selectedResultId].map((x) => x.ID);
      }
    }
    else
    {
    Object.keys(this.indicatorMapping).forEach((x) => {
      var indicators = this.indicatorMapping[x].map((x) => x.ID);
      usedIds = [...usedIds, ...indicators];
    });
    }

    return this.items.filter(
      (x) => !usedIds.includes(x.ID) && x.IsStandard === true
    );
  }

  indicatorTabs = [
    { text: "Select Indicator(s)", id: 0 },
    { text: "Add custom indicator", id: 1 },
  ];

  get indicatorTypes() {
    return this.indicatorTabs.filter(x => x.id == 0 || (x.id == 1 && this.allowCustomIndicator));
  }

  headers: any = [
    { text: "Indicator", sortable: true, value: "Description" },
    // { text: "Standard", value: "IsStandard" }
  ];

  /** show/hide table rows */
  toggleVisibility(data) {
    if (this.hiddenChild.includes(data)) {
      // show hidden row
      const index = this.hiddenChild.indexOf(data);
      this.hiddenChild.splice(index, 1);
    } else {
      this.hiddenChild.push(data); // adding new hidden row
    }
  }

  get hidden() {
    return this.hiddenChild;
  }

  get datum() {
    return this.appData.monitoringPlan.data;
  }

  get indicatorMapping() {
    return this.appData.monitoringPlan.indicators;
  }

  /** show dialog */
  showdialog(id: string) {
    this.selectedResultId = id;
    this.indicatorDialog = true;
    this.newObj.Code = `C${this.cusIndex}`;
    this.newObj.DataTypeId = _app.customIndicatorDataTypes[0].Value; // numeric type selectd by default
  }

  /** edit the indicator */
  editIndicator(id, index, indicatorId) {
    this.selectedResultId = id;
    this.selectedIndex = index;
    this.$services.application
      .getCustomIndicator(indicatorId)
      .then((indicator) => {
        this.selectedObj = indicator;
        this.editDialog = true;
      });
  }

 /** save the indicator */
  saveIndicator() {
    this.updateIndicator({
      data: this.selectedObj,
      id: this.ApplicationId,
    }).then((indicator) => {
      let dataType=this.indicatorMapping[this.selectedResultId][this.selectedIndex].DataType;
      if(indicator && indicator.ID && dataType!=indicator.DataType)
      {
        this.datum[this.selectedResultId][indicator.ID]={}
      }
      this.indicatorMapping[this.selectedResultId][
        this.selectedIndex
      ] = indicator;
      this.selectedObj = {};
      this.editDialog = false;
    });
    this.$emit('change', true);
  }
  

  /** delete the mapping */
  deleteMapping(id, index, indicatorId) {
    delete this.datum[id][indicatorId];
    this.indicatorMapping[id].splice(index, 1);
    this.key += 1;
    this.$emit('change', true);
  }

  /** select the indicator */
  apply() {
    const self = this;
    if (this.activeTab == 1) {
      this.createCustomIndicator({
        data: this.newObj,
        id: this.ApplicationId,
      }).then((data) => {
        if (data.Result === "ERROR") {
          return;
        }

        self.selected = [self.items[self.items.length - 1]];
        self.newObj = {};
        this.cusIndex += 1;
        this.useCustomIndicator = false;

        if (!this.indicatorMapping[this.selectedResultId]) {
          this.indicatorMapping[this.selectedResultId] = [];
        }

        if (!this.datum[this.selectedResultId]) {
          this.datum[this.selectedResultId] = {};
        }

        this.selected.forEach((row) => {
          self.indicatorMapping[this.selectedResultId].push(row);
          self.datum[this.selectedResultId][row.ID] = {};
        });

        this.selected = [];
        this.selectedResultId = "";
        this.indicatorDialog = false;
      });
    } else {
      if (!this.indicatorMapping[this.selectedResultId]) {
        this.indicatorMapping[this.selectedResultId] = [];
      }

      if (!this.datum[this.selectedResultId]) {
        this.datum[this.selectedResultId] = {};
      }

      this.selected.forEach((row) => {
        self.indicatorMapping[this.selectedResultId].push(row);
        self.datum[this.selectedResultId][row.ID] = {};
      });

      this.selected = [];
      this.selectedResultId = "";
      this.indicatorDialog = false;
    }
    this.$emit('change', true);
  }
}
